export interface Favorite {
  id: number;
  created_at: string;
  updated_at: string;
  remote_id: string | null;
  place: string | null;
  event: string | null;
  restaurant_event: string | null;
  person: number | null;
  material: number | null;
  user: string;
}
export interface IFavorite extends Favorite {
  kind: keyof typeof FavoriteKinds;
}

export const FavoriteKinds: {
  event: 'event';
  place: 'place';
  person: 'person';
  material: 'material';
} = {
  event: 'event',
  place: 'place',
  person: 'person',
  material: 'material',
};

export const FavoriteKindsV5 = {
  event: 'events.event',
  place: 'events.place',
  person: 'specializations.person',
  material: 'blog.material',
};

export interface FavoriteV5 {
  id: number;
  object_id: number;
  content_type:
    | 'blog.material'
    | 'events.place'
    | 'specializations.person'
    | 'events.event';
  created_at: string;
  updated_at: string;
  content_object: any;
}

export interface FavoriteV5Short {
  id: number;
  object_id: number;
  content_type:
    | 'blog.material'
    | 'events.place'
    | 'specializations.person'
    | 'events.event';
}
